/**
 * 用户相关 相关菜单配置
 *
 */

// import Layout from "../components/layout";
import { lazyLoad } from "@/utils/lazyLoad";
const userRoute = [
  {
    // component: Layout,
    component: lazyLoad,
    path: "user-management",
    name: "userManagement",
    meta: {
      title: "用户",
      icon: "icon-operations",
    },
    hidden: true,
    children: [
      {
        path: "/user/editPassword",
        name: "editPassword",
        component: () => import("../pages/user/editPassword/index.vue"),
        meta: {
          title: "修改密码",
          icon: "banner",
        },
      },
    ],
  },
];
export default userRoute;
